// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// This file provides the default MSAL configuration for the add-in project.

import { LogLevel } from "@azure/msal-browser";
import { createLocalUrl } from "./util";

/* global console */

export const clientId = "a921c463-995c-4cf2-a638-7808de7bba02";
//export const clientId = "37b424dd-a13f-46b2-a23d-4d95aae29430"; // Demo Id

//redirectUri: createLocalUrl("https://particlemailer.com/auth.html"),
export const msalConfig = {
  auth: {
    clientId,
    redirectUri: "https://particlemailer.com/auth.html",
    postLogoutRedirectUri: createLocalUrl("auth.html"),
    authority: "https://login.microsoftonline.com/common",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Verbose,
      loggerCallback: (level: LogLevel, message: string) => {
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      piiLoggingEnabled: true,
    },
  },
};

// Default scopes to use in the fallback dialog.
export const defaultScopes = ["user.read", "mail.read"];
